import apiClient from '@shared/api/apiClient';
/**
 * 비밀번호 변경 API
 * @param {Object} payload - { pw: string, changePw: string }
 * @returns {Promise<Object>}
 */
async function putModfyPassword(payload) {
  const response = await apiClient.put('/v1/users/me/password', payload, { withAuth: true });
  return response.data;
}
export { putModfyPassword };
